import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Trash2, Plus } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../../ui/dialog';
import { Input } from '../../ui/input';
import { Button } from '../../ui/button';
import { API, auth, err } from './invoiceApi';

export const ServicesEditor = ({ services, token, onClose, onSaved }) => {
  const [rows, setRows] = useState(services.map((s) => ({ ...s })));
  const up = (i, p) => setRows(rows.map((r, j) => (j === i ? { ...r, ...p } : r)));
  const save = async () => {
    try {
      const r = await axios.put(`${API}/admin/invoice-services`, { items: rows.filter((x) => x.name.trim()).map((x) => ({ ...x, unit_price: Number(x.unit_price) || 0 })) }, auth(token));
      toast.success('Services list saved'); onSaved(r.data.services); onClose();
    } catch (e) { toast.error(err(e, 'Could not save services')); }
  };
  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent className="max-w-xl" data-testid="services-editor">
        <DialogHeader><DialogTitle>Saved services</DialogTitle><DialogDescription>Reusable lines for invoices. The price is a default you can change on each invoice.</DialogDescription></DialogHeader>
        <div className="space-y-2 max-h-[50vh] overflow-y-auto">
          {rows.map((r, i) => (
            <div key={r.id || i} className="flex gap-2" data-testid={`service-row-${i}`}>
              <Input value={r.name} onChange={(e) => up(i, { name: e.target.value })} placeholder="Service name" data-testid={`service-name-${i}`} />
              <Input type="number" min="0" step="0.01" value={r.unit_price} onChange={(e) => up(i, { unit_price: e.target.value })} className="w-28" data-testid={`service-price-${i}`} />
              <Button variant="ghost" size="sm" onClick={() => setRows(rows.filter((_, j) => j !== i))} data-testid={`service-remove-${i}`}><Trash2 className="w-4 h-4 text-red-500" /></Button>
            </div>
          ))}
        </div>
        <div className="flex justify-between">
          <Button variant="outline" size="sm" onClick={() => setRows([...rows, { name: '', description: '', unit_price: 0 }])} data-testid="service-add"><Plus className="w-3 h-3 mr-1" />Add service</Button>
          <Button size="sm" onClick={save} data-testid="services-save">Save list</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
